import { ReactNode } from "react";

const iconProps = {
    width: 20,
    height: 20,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
} as const

const strokeProps = {
    stroke: 'currentColor',
    strokeWidth: 1.9,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
} as const

const HomeIcon = () => (
    <svg {...iconProps}>
        <path d="M3 10.5L12 3L21 10.5" {...strokeProps} />
        <path d="M5 9.5V20H19V9.5" {...strokeProps} />
        <path d="M10 20V14H14V20" {...strokeProps} />
    </svg>
)

const StudentsIcon = () => (
    <svg {...iconProps}>
        <path d="M8.5 11.5C10.433 11.5 12 9.933 12 8C12 6.067 10.433 4.5 8.5 4.5C6.567 4.5 5 6.067 5 8C5 9.933 6.567 11.5 8.5 11.5Z" {...strokeProps} />
        <path d="M15.5 10.5C17.157 10.5 18.5 9.157 18.5 7.5C18.5 5.843 17.157 4.5 15.5 4.5" {...strokeProps} />
        <path d="M3.5 19.5C4.227 16.885 6.559 15 9.327 15H9.673C12.441 15 14.773 16.885 15.5 19.5" {...strokeProps} />
        <path d="M15 15.5C16.881 15.827 18.402 17.175 19 19" {...strokeProps} />
    </svg>
)

const TutorsIcon = () => (
    <svg {...iconProps}>
        <path d="M12 4L20 8L12 12L4 8L12 4Z" {...strokeProps} />
        <path d="M7 10.5V15.5C7 17.433 9.239 19 12 19C14.761 19 17 17.433 17 15.5V10.5" {...strokeProps} />
        <path d="M20 8V14" {...strokeProps} />
    </svg>
)

const WorkTgsIcon = () => (
    <svg {...iconProps}>
        <rect x="4" y="5" width="16" height="14" rx="3" {...strokeProps} />
        <path d="M8 9H16" {...strokeProps} />
        <path d="M8 13H13" {...strokeProps} />
        <path d="M8 17H11" {...strokeProps} />
    </svg>
)

const TeamsIcon = () => (
    <svg {...iconProps}>
        <path d="M7 8.5C8.381 8.5 9.5 7.381 9.5 6C9.5 4.619 8.381 3.5 7 3.5C5.619 3.5 4.5 4.619 4.5 6C4.5 7.381 5.619 8.5 7 8.5Z" {...strokeProps} />
        <path d="M17 8.5C18.381 8.5 19.5 7.381 19.5 6C19.5 4.619 18.381 3.5 17 3.5C15.619 3.5 14.5 4.619 14.5 6C14.5 7.381 15.619 8.5 17 8.5Z" {...strokeProps} />
        <path d="M12 20.5C13.381 20.5 14.5 19.381 14.5 18C14.5 16.619 13.381 15.5 12 15.5C10.619 15.5 9.5 16.619 9.5 18C9.5 19.381 10.619 20.5 12 20.5Z" {...strokeProps} />
        <path d="M8.5 7.5L10.8 15" {...strokeProps} />
        <path d="M15.5 7.5L13.2 15" {...strokeProps} />
        <path d="M9.5 6H14.5" {...strokeProps} />
    </svg>
)

const TagsIcon = () => (
    <svg {...iconProps}>
        <path d="M11 4H6C4.895 4 4 4.895 4 6V11L13 20L20 13L11 4Z" {...strokeProps} />
        <path d="M8.5 8.5H8.51" {...strokeProps} />
    </svg>
)

const FinanceIcon = () => (
    <svg {...iconProps}>
        <path d="M12 3V21" {...strokeProps} />
        <path d="M16.5 7.5C16.5 5.843 14.485 4.5 12 4.5C9.515 4.5 7.5 5.843 7.5 7.5C7.5 9.157 9.515 10.5 12 10.5C14.485 10.5 16.5 11.843 16.5 13.5C16.5 15.157 14.485 16.5 12 16.5C9.515 16.5 7.5 15.157 7.5 13.5" {...strokeProps} />
    </svg>
)

const LegalInfoIcon = () => (
    <svg {...iconProps}>
        <path d="M12 3V21" {...strokeProps} />
        <path d="M5 7H19" {...strokeProps} />
        <path d="M4 7L7 3H17L20 7" {...strokeProps} />
        <path d="M5.5 21H18.5" {...strokeProps} />
        <path d="M7.5 7L5.5 16.5C5.237 17.75 6.192 19 7.47 19H7.53C8.808 19 9.763 17.75 9.5 16.5L7.5 7Z" {...strokeProps} />
        <path d="M16.5 7L14.5 16.5C14.237 17.75 15.192 19 16.47 19H16.53C17.808 19 18.763 17.75 18.5 16.5L16.5 7Z" {...strokeProps} />
    </svg>
)

const StatisticsIcon = () => (
    <svg {...iconProps}>
        <path d="M4 20V11" {...strokeProps} />
        <path d="M10 20V5" {...strokeProps} />
        <path d="M16 20V8" {...strokeProps} />
        <path d="M22 20H2" {...strokeProps} />
    </svg>
)

const LessonsIcon = () => (
    <svg {...iconProps}>
        <rect x="4" y="5" width="16" height="15" rx="3" {...strokeProps} />
        <path d="M8 3V7" {...strokeProps} />
        <path d="M16 3V7" {...strokeProps} />
        <path d="M4 10H20" {...strokeProps} />
        <path d="M9 14H12" {...strokeProps} />
        <path d="M9 17H15" {...strokeProps} />
    </svg>
)

const TransactionsIcon = () => (
    <svg {...iconProps}>
        <path d="M7 7H18V18" {...strokeProps} />
        <path d="M17.5 7.5L6 19" {...strokeProps} />
        <path d="M16 4H20V8" {...strokeProps} />
        <path d="M8 20H4V16" {...strokeProps} />
    </svg>
)

const CalendarIcon = () => (
    <svg {...iconProps}>
        <rect x="4" y="5" width="16" height="15" rx="3" {...strokeProps} />
        <path d="M8 3V7" {...strokeProps} />
        <path d="M16 3V7" {...strokeProps} />
        <path d="M4 10H20" {...strokeProps} />
        <path d="M8 14H8.01" {...strokeProps} />
        <path d="M12 14H12.01" {...strokeProps} />
        <path d="M16 14H16.01" {...strokeProps} />
        <path d="M8 17H8.01" {...strokeProps} />
        <path d="M12 17H12.01" {...strokeProps} />
        <path d="M16 17H16.01" {...strokeProps} />
    </svg>
)

const AssistantsIcon = () => (
    <svg {...iconProps}>
        <path d="M8 11.5C9.933 11.5 11.5 9.933 11.5 8C11.5 6.067 9.933 4.5 8 4.5C6.067 4.5 4.5 6.067 4.5 8C4.5 9.933 6.067 11.5 8 11.5Z" {...strokeProps} />
        <path d="M15.5 12.5L17 14L20 10.5" {...strokeProps} />
        <path d="M4 19C4.62 16.67 6.713 15 9.18 15H9.82C11.116 15 12.31 15.461 13.24 16.229" {...strokeProps} />
    </svg>
)

const AdminsIcon = () => (
    <svg {...iconProps}>
        <path d="M12 4L18.5 7.5V12C18.5 15.866 15.866 19.366 12 20C8.134 19.366 5.5 15.866 5.5 12V7.5L12 4Z" {...strokeProps} />
        <path d="M9.5 12L11 13.5L14.5 10" {...strokeProps} />
    </svg>
)

const IdmIcon = () => (
    <svg {...iconProps}>
        <rect x="4" y="4" width="7" height="7" rx="2" {...strokeProps} />
        <rect x="13" y="4" width="7" height="7" rx="2" {...strokeProps} />
        <rect x="4" y="13" width="7" height="7" rx="2" {...strokeProps} />
        <path d="M16.5 13V20" {...strokeProps} />
        <path d="M13 16.5H20" {...strokeProps} />
    </svg>
)

const StaffIcon = () => (
    <svg {...iconProps}>
        <path d="M8 11.5C9.933 11.5 11.5 9.933 11.5 8C11.5 6.067 9.933 4.5 8 4.5C6.067 4.5 4.5 6.067 4.5 8C4.5 9.933 6.067 11.5 8 11.5Z" {...strokeProps} />
        <path d="M16 10.5C17.657 10.5 19 9.157 19 7.5C19 5.843 17.657 4.5 16 4.5" {...strokeProps} />
        <path d="M3.8 19C4.451 16.704 6.564 15 9.033 15H9.467C11.936 15 14.049 16.704 14.7 19" {...strokeProps} />
        <path d="M14.5 15.5C16.178 15.819 17.538 17.003 18.2 18.6" {...strokeProps} />
    </svg>
)

const PayoutsIcon = () => (
    <svg {...iconProps}>
        <rect x="3.5" y="6" width="17" height="12" rx="3" {...strokeProps} />
        <path d="M7 12H17" {...strokeProps} />
        <path d="M7 15H13" {...strokeProps} />
        <path d="M16.5 9H16.51" {...strokeProps} />
    </svg>
)

const FallbackIcon = () => (
    <svg {...iconProps}>
        <circle cx="12" cy="12" r="8" {...strokeProps} />
    </svg>
)

const ICONS_BY_LINK: Record<string, ReactNode> = {
    '/': <HomeIcon />,
    '/students': <StudentsIcon />,
    '/tutors': <TutorsIcon />,
    '/work_tgs': <WorkTgsIcon />,
    '/teams': <TeamsIcon />,
    '/staff': <StaffIcon />,
    '/performers': <TutorsIcon />,
    '/students_tags': <TagsIcon />,
    '/idm': <IdmIcon />,
    '/finance': <FinanceIcon />,
    '/legal-info': <LegalInfoIcon />,
    '/statistics': <StatisticsIcon />,
    '/lessons': <LessonsIcon />,
    '/transactions': <TransactionsIcon />,
    '/assistants': <AssistantsIcon />,
    '/admins': <AdminsIcon />,
    '/tutor_lessons': <LessonsIcon />,
    '/tutor_finance': <FinanceIcon />,
    '/tutor_accruals': <PayoutsIcon />,
    '/calendar': <CalendarIcon />,
    '/shifts': <CalendarIcon />,
    '/events': <TransactionsIcon />,
}

export const getNavIcon = (link: string) => ICONS_BY_LINK[link] ?? <FallbackIcon />
